export default __webpack_public_path__ + "static/media/laptop.f636b352.jpg";